import PropTypes from 'prop-types';
import _values from 'lodash/values';

// Constants
import FILTER_TYPES from './filterSection.filterTypes';
export var FILTER_PROPTYPE = {
  id: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.oneOf(_values(FILTER_TYPES)),
  additional: PropTypes.object
};
export var SELECTED_FILTER_GROUP_PROPTYPE = PropTypes.string;